import { IAgentLoginResponse } from "../app/modules/auth/models/response";
import { AUTH_LOCAL_STORAGE_KEY } from "../app/modules/common/redux/ApiClient";

export const getAuth = (): IAgentLoginResponse | undefined => {
  if (localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)) {
    return JSON.parse(localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)!);
  }
  return undefined;
};
